<template lang="html">
  <div class="detailsddd">
    <div class="detailsContent">
      <div class="oneDetail" v-for="(criteria, c ) in knownVote" :key="c">
        <div class="value">
            <span class="voteValue">{{formattedNumber(criteria.percentage)}}%</span>
            <span class="voteCriteria">{{ $t(criteria.level)}}</span>
        </div>
        <div class="progress-bar">
          <div class="progress-bar-fill" :style="{ width: criteria.percentage + '%' }"></div>
        </div>
      </div>

    </div>
  </div>

</template>


<script>
export default {
  name : "InterestRepartitionDetailsInside",
  methods:{
    computedProgress(value) {
         // Make sure progress is between 0 and 100
         return Math.max(0, Math.min(100, (value / 5) * 100));
       },

       formattedNumber(number) {
             return new Intl.NumberFormat('fr-FR', {
               style: 'decimal',
               minimumFractionDigits: 0,
               maximumFractionDigits: 1
             }).format(number);
       },

  },
  computed: {
   // Filter the array passed via props
   knownVote() {
     return this.vote.collabInterestLevelDistribution.filter(item => item.percentage != null);
   }
 },
  props: ["vote"]
}
</script>

<style media="screen" scoped>
.detailsContent{
 display: flex;
 flex-direction: column;
 gap:20px;
 font-size:14px;
 line-height: 20px;
}
.oneDetail{

}
.value{
  display:flex;
  align-items: center;
  gap:10px;
}
.voteValue{
  font-weight: 100;
  font-size:32px;
  color:#0A2071;
  line-height: 35px;
}
.voteCriteria{
  color:#0A2071;
  font-size:16px;
  font-weight: 100;
}

.progress-bar {
  margin-top:10px;
  width: 100%;
  height: 8px; /* Adjust the height to match your example */
  background-color: #FFF2D2; /* Light blue background color */
  border-radius: 4px; /* Rounded corners */
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background-color: #B38D2F; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}

</style>
